<div class="customer-unbind">
  <app-action-dropdown-menu
    [actionsList]="['UNBIND_CUSTOMER']"
    (actionSelected)="unbindCustomerClick()"
  />
</div>
<form
  class="form"
  [formGroup]="customerFormGroup()"
>
  @for (field of customerFormFields; track $index) {
    <mat-form-field
      appearance="outline"
      [class]="getClasses()"
      [style.cursor]="getFieldStyles(field.fieldName)"
      (click)="handleOpenUrlClick(field.fieldName)"
    >
      <mat-label>
        {{ field.label }}
      </mat-label>
      <input
        matInput
        [type]="field.type"
        [formControlName]="field.fieldName"
        (change)="handleUpdateCustomer(field.fieldName)"
      >
    </mat-form-field>
  }
</form>
